module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "请稍等···"
    }
  }, [_c('div', {
    staticClass: "page-container"
  }, [_c('UnableFailoverJobs', {
    attrs: {
      "unable-failover-jobs-list": _vm.unableFailoverJobsList
    },
    on: {
      "refresh-list": _vm.getUnableFailoverJobs
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a0938ff"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/alarm_manage/unable_failover_jobs.vue
// module id = 1426
// module chunks = 1